import { defineComponent, computed, ref, PropType, watch, reactive, SetupContext } from "@vue/composition-api";

const clamp = (v:number, min:number, max:number) => v < min ? min : (v > max ? max : v);

import { getQueryValue, setQueryValue } from "./utils";

type Config = {
	context:SetupContext;
	queryPrefix:string;
};

export const usePagination = (c:Config) => {

	const {
		context,
		queryPrefix,
	} = c;


	const pageOptions = computed(() => [ 5, 10, 20, 50 ].map(v => ({ value:v, text:v.toString() })));
	
	const limit = ref(Number(getQueryValue(`${queryPrefix}_limit`, context, 10)));
	
	const total = ref(0);

	const currentPage = ref(Number(getQueryValue(`${queryPrefix}_page`, context, 1)));

	// let initialPage = currentPage.value;

	const minLabel = computed(() => {
		const min = (currentPage.value - 1) * limit.value + 1;
		return min;
	});

	const maxLabel = computed(() => {
		const max = clamp((currentPage.value - 1) * limit.value + limit.value, 0, total.value);
		return max;
	});

	watch(limit, v => {
		setQueryValue(`${queryPrefix}_limit`, v, context);
	});

	watch(currentPage, v => {
		setQueryValue(`${queryPrefix}_page`, v, context);
	});

	// watch(currentPage, v => {
	// 	if(initialPage < 0){ return; }
	// 	setTimeout(() => {
	// 		currentPage.value = initialPage;
	// 		initialPage = -1;
	// 	}, 1000);
	// })

	return {
		pageOptions,
		total,
		perPage:limit,
		currentPage,
		minLabel,
		maxLabel,
	};

};


